import { Partners } from '@/components/sections/home';
import { DynamicPartnersBlockFragment } from '@/graphql/generated';

export const DynamicPartnersSection = ({ header, partners }: DynamicPartnersBlockFragment) => {
  return <Partners partners={partners.data} variant="light" header={header} />;
};
